<main class="bigger-tiles padding" *ngIf="records">
        <ng-container *ngFor="let row of records">
                <app-event-ore-deposit-tile *ngIf="row.data.deposit_type == 'ore' && row.data.child_count > 0" [event_id]="event_id" [deposit]="row"></app-event-ore-deposit-tile>
                <app-event-cargo-deposit-tile *ngIf="row.data.deposit_type == 'cargo'  && row.data.child_count > 0" [event_id]="event_id" [deposit]="row"></app-event-cargo-deposit-tile>
        </ng-container>
</main>
